
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Mail } from 'lucide-react';
import { SignupFormConfig } from '@/schemas/signupFormSchema';

interface EmailSettingsProps {
  formConfig: SignupFormConfig;
  setFormConfig: React.Dispatch<React.SetStateAction<SignupFormConfig>>;
}

const EmailSettings: React.FC<EmailSettingsProps> = ({ formConfig, setFormConfig }) => {
  const handleCcEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormConfig(prev => ({ ...prev, ccEmail: e.target.value }));
  };

  const handleEnableCcChange = (checked: boolean) => {
    setFormConfig(prev => ({ ...prev, enableCcEmail: checked }));
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center gap-2 mb-4">
          <Mail className="h-5 w-5 text-primary" />
          <h3 className="text-lg font-medium">Email Settings</h3>
        </div>
        
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Switch
              id="enableCcEmail"
              checked={formConfig.enableCcEmail}
              onCheckedChange={handleEnableCcChange}
            />
            <Label htmlFor="enableCcEmail">Send a copy to support email</Label>
          </div>
          
          {formConfig.enableCcEmail && (
            <div className="space-y-2">
              <Label htmlFor="ccEmail">Support Email Address</Label>
              <Input
                id="ccEmail"
                type="email"
                placeholder="support@example.com"
                value={formConfig.ccEmail}
                onChange={handleCcEmailChange}
              />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default EmailSettings;
